import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from "../Units/Header";
import '../../assets/stylesheets/LeaderBoard/Rewards.scss'
import rewards from '../../config/rewards';


const LeaderBoardRewards = ({}) => {
  const { t } = useTranslation();
  const [selectedPeriod, setPeriod] = useState('monthly');
  const firstColumn = rewards['rewards'].slice('',10);
  const secondColumn = rewards['rewards'].slice(10);

  const periods = [t('leaderboard.daily'), t('leaderboard.weekly,'), t('leaderboard.monthly')];

  return (
    <React.Fragment>
      <Header title='leaderboardInfoTitle' backTo={'/leaderboard'} ></Header>
      <div className={`periodChoice`}>
        {
          periods.map((period, index) => <div key={index} className={`period ${period}Period ${(selectedPeriod === period) ? 'selected' : ''}`} onClick={() => setPeriod(period)}>{period}</div>)
        }
      </div>
      <div className={`rewards`}>
        <div className={`firstColumn`}>
          <div className={`rewardText`}><span>{t('leaderboard.rank')}</span><span>{t('leaderboard.reward}')}</span> </div>
          {firstColumn.map((item) => (
            <div className={`rewardItem`}>
                <div>{item.position}</div>
                <div className={`reward ${item.reward && item.reward.currency}`}>
                  {item.reward && item.reward[selectedPeriod]}
                </div>
          </div>
          ))}
        </div>
        <div className={`secondColumn`}>
          <div className={`rewardText`}><span>{t('leaderboard.rank')}</span><span>{t('leaderboard.reward')}</span> </div>
          {secondColumn.map((item) => (
            <div className={`rewardItem`}>
              <div>{item.position}</div>
              <div className={`reward ${item.reward && item.reward.currency}`}>
                {item.reward && item.reward[selectedPeriod]}
              </div>
          </div>
          ))}
        </div>
      </div>
    </React.Fragment>
    );
}

export default LeaderBoardRewards;